/* unplugin-vue-components disabled */import { render } from "./RedemptionDetailCpt.vue?vue&type=template&id=10b7b312&scoped=true"
import script from "./RedemptionDetailCpt.vue?vue&type=script&lang=js"
export * from "./RedemptionDetailCpt.vue?vue&type=script&lang=js"

import "./RedemptionDetailCpt.vue?vue&type=style&index=0&id=10b7b312&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b7b312"]])

export default __exports__